import React from 'react';
import { Card } from 'antd';

import ProcessFollowUp from 'components/ProcessFollowUp';

type TPProcessFollowUpProps = {
  tpid: number;
  refetch?: boolean;
  refetchProp?: any;
};
const TPProcessFollowUp = (props: TPProcessFollowUpProps) => {
  const { tpid,refetch,refetchProp } = props;
  return (
    <Card>
      <ProcessFollowUp entity="THIRDPARTY" refetech={refetch} entityid={tpid} entityReference='' refetchProp={refetchProp}></ProcessFollowUp>
    </Card>
  );
};

export default TPProcessFollowUp;
